import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgrxMatSelectViewAdapter } from './mat-select-view-adapter';
import { CustomErrorStateMatcherDirective } from './error-state-matcher';
// pipes
import { UnboxPipe } from './_pipes/unbox.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [NgrxMatSelectViewAdapter, CustomErrorStateMatcherDirective, UnboxPipe],
  exports: [NgrxMatSelectViewAdapter, CustomErrorStateMatcherDirective, UnboxPipe]
})
export class SharedNgrxFormsModule {}
